/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  MenuItem,
  NavDropdown,
} from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import isEqual from 'lodash/isEqual';
import HideIf from 'loracoms/HideIf';
import authActions from 'loraactions/auth';
import IntlMsg from 'lorautils/intl/IntlMsg';

import imgTrialUser from './images/trial-user.svg';
import imgTrialUserEx from './images/trial-user-expired.svg';
import imgLabUser from './images/svcpkg-user.svg';
import imgLabUserEx from './images/svcpkg-user-expired.svg';
import imgCommUser from './images/comm-user.svg';
import imgCommUserEx from './images/comm-user-expired.svg';

const propTypes = {
  intl: PropTypes.object.isRequired,
  push: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  basic: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
};

class UserDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      basic: props.basic,
      plan: props.plan,
    };
    this.intlMsg = new IntlMsg(props.intl, 'common');
    this.handleLogout = this.handleLogout.bind(this);
    this.handleGotoAccountCenter = this.handleGotoAccountCenter.bind(this);
    this.handleGotoBillingPlans = this.handleGotoBillingPlans.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { basic, plan } = nextProps;
    if (!isEqual(basic, this.props.basic)) {
      this.setState({ basic });
    }
    if (!isEqual(plan, this.props.plan)) {
      this.setState({ plan });
    }
  }

  handleGotoAccountCenter() {
    this.props.push('/accountcenter');
    this.props.onSelect();
  }

  handleGotoBillingPlans() {
    this.props.push('/billing');
    this.props.onSelect();
  }

  handleLogout() {
    sessionStorage.removeItem('roadtest');
    this.props.logout();
    this.props.onSelect();
  }

  renderUserIcon() {
    const { plan: { data: planData } } = this.state;
    switch (planData.tier) {
      case 1:
        return (
          planData.expired
          ? <img src={imgTrialUserEx} alt="" />
          : <img src={imgTrialUser} alt="" />
        );
      case 2:
        return (
          planData.expired
          ? <img src={imgLabUserEx} alt="" />
          : <img src={imgLabUser} alt="" />
        );
      case 3:
        return (
          planData.expired
          ? <img src={imgCommUserEx} alt="" />
          : <img src={imgCommUser} alt="" />
        );
      default:
        return (
          planData.expired
          ? <img src={imgTrialUserEx} alt="" />
          : <img src={imgTrialUser} alt="" />
        );
    }
  }

  render() {
    const {
      plan: { data: planData },
      basic: { data: basicData },
    } = this.state;

    if (!planData || !basicData) {
      return null;
    }

    const title = <span>{this.renderUserIcon()}{' '}{basicData.name}</span>;
    return (
      <NavDropdown
        id="nav-dropdown"
        pullRight
        eventKey={6}
        title={title}
      >
        <MenuItem eventKey="6.1" onClick={this.handleGotoAccountCenter}>
          <span className="halflings halflings-user" />
          {this.intlMsg.msg('accountmanage')}
        </MenuItem>
        <HideIf if="profile:cube">
          <MenuItem eventKey="6.2" onClick={this.handleGotoBillingPlans}>
            <span className="halflings halflings-usd" />
            {this.intlMsg.msg('accountupgrade')}
          </MenuItem>
        </HideIf>
        <MenuItem divider />
        <MenuItem eventKey="6.3" onClick={this.handleLogout}>
          <span className="halflings halflings-log-out" />
          {this.intlMsg.msg('exit')}
        </MenuItem>
      </NavDropdown>
    );
  }
}

UserDropdown.propTypes = propTypes;

const mapStateToProps = state => ({
  basic: state.account.basic,
  plan: state.billing.plan,
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(authActions.revoke()),
  push: (...args) => dispatch(push(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(UserDropdown));




// WEBPACK FOOTER //
// ./src/containers/App/coms/UserDropdown/index.jsx